import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: '/',

    routes: [{
        path: '/',
        name: 'home',
        component: Home
    }, {
        path: '/products',
        name: 'products',
        component: () => import('./views/Products.vue')
    }, {
        path: '/applications',
        name: 'applications',
        component: () => import('./views/Applications.vue')
    }, {
        path: '/partners',
        name: 'partners',
        component: () => import('./views/Partners.vue')
    }, {
        path: '/webinar',
        name: 'webinar',
        component: () => import('./views/Webinar.vue')
    }, {
        path: '/about',
        name: 'about',
        component: () => import('./views/About.vue')
    }, {
        path: '/contact',
        name: 'contact',
        component: () => import('./views/Contact.vue')
    }]
})
